import AjaxService from '../services/ajax-service';

export const fetchTokens = () => {
    return AjaxService({
        method: 'get',
        url: `invites`
    }).then(response => response.data);
}

export const createToken = (url, role, project_id) => {
    return AjaxService({
        method: 'post',
        url: 'invites',
        data: {
            url,
            role,
            project_id
        }
    }).then(response => response.data);
}

export const removeToken = tokenId => {
    return AjaxService({
        method: 'delete',
        url: `invites/${tokenId}`
    }).then(response => response.data);
}
